import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { castArray } from 'lodash';
import ImageItem from './ImageItem';
import UploadedItem from './UploadQueue/UploadedItem';

const propTypes = {
  items: PropTypes.array.isRequired, // Media data
  onChange: PropTypes.func.isRequired,
  onDoubleClick: PropTypes.func.isRequired,
  selected: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.number,
    PropTypes.arrayOf(PropTypes.number),
  ]),
  multiple: PropTypes.bool,
};

const defaultProps = {
  multiple: true,
  selected: false,
};

class ImageList extends Component {
  constructor(props) {
    super(props);
    this.renderItem = this.renderItem.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.onUnselect = this.onUnselect.bind(this);
    this.isSelected = this.isSelected.bind(this);
    this.onDoubleClick = this.onDoubleClick.bind(this);
  }

  onSelect(mediaId) {
    const { multiple, selected, onChange } = this.props;
    let values = mediaId;

    if (multiple) {
      const prevSelection = castArray(selected).filter(i => i != null);
      values = [...prevSelection, mediaId];
    }

    if (onChange) {
      onChange(values);
    }
  }

  onUnselect(mediaId) {
    const { multiple, selected, onChange } = this.props;
    let values = castArray(selected).filter(i => i != null);

    if (multiple) {
      values = values.filter(id => id !== mediaId);
    }

    if (onChange) {
      onChange(values);
    }
  }

  onDoubleClick(id) {
    this.props.onDoubleClick(id);
  }

  isSelected(imageId) {
    const { selected } = this.props;

    if (Array.isArray(selected)) {
      return selected.includes(imageId);
    }

    if (Number.isInteger(Number(selected))) {
      return selected === imageId;
    }

    return false;
  }

  renderItem(image) {
    return image.isUploading
      ? this.renderUploadingPlaceholder(image)
      : this.renderImage(image);
  }

  renderUploadingPlaceholder = ({ uniqueId, file, progress }) => (
    <li key={uniqueId} className="c-bb-media-manager__list-item">
      <UploadedItem
        filename={file.name}
        progress={progress}
      />
    </li>
  );

  renderImage = image => (
    <li key={image.id} className="c-bb-media-manager__list-item">
      <ImageItem
        key={image.id}
        onSelect={this.onSelect}
        onUnSelect={this.onUnselect}
        onDoubleClick={this.onDoubleClick}
        isSelected={this.isSelected(image.id)}
        {...image}
      />
    </li>
  );

  render() {
    const {
      items,
    } = this.props;

    if (items.length) {
      return (
        <ul className="c-bb-media-manager__list">
          { items.map(this.renderItem) }
        </ul>
      );
    }

    return null;
  }
}

ImageList.propTypes = propTypes;
ImageList.defaultProps = defaultProps;

export { ImageList as default };



// WEBPACK FOOTER //
// ./src/components/MediaManager/ImageList.js